import React, { useState, useEffect } from "react";
import Logo from '../../assets/bochlogo.png';

function Regd() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // 1. Scroll effect (your existing logic)
  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById("hero");
      if (hero) {
        const triggerPoint = hero.offsetTop + hero.offsetHeight;
        setScrolled(window.scrollY >= triggerPoint);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 2. Toggle menu and handle body scroll lock (matches your JS logic)
  const toggleMenu = () => {
    const newState = !isMenuOpen;
    setIsMenuOpen(newState);
    document.body.style.overflow = newState ? 'hidden' : '';
  };

  // 3. Close menu when any link is clicked
  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <div className="regd">
      <nav id="mainNav" className={scrolled ? "scrolled" : ""}>
        
        <a href="#hero" className="nav-logo">
          <img src={Logo} style={{ maxWidth: '75px' }} alt="Logo" />
        </a>

        {/* Hamburger button: toggles 'active' class based on state */}
        <div 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          id="hamburger" 
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Nav menu: toggles 'active' class based on state */}
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`} id="navMenu">
          <ul className="nav-links">
            <li><a href="#intro" onClick={closeMenu}>Company</a></li>
            <li><a href="#reasons" onClick={closeMenu}>Why Invest</a></li>
            <li><a href="#business" onClick={closeMenu}>Business</a></li>
            <li><a href="#terms" onClick={closeMenu}>Offering</a></li>
            <li><a href="#team" onClick={closeMenu}>Team</a></li>
            <li><a href="login" onClick={closeMenu}>Login</a></li>
          </ul>
          <a href="signup" className="btn-nav" onClick={closeMenu}>Invest Now</a>
        </div>

      </nav>
    </div>
  );
}

export default Regd;